module.exports = __webpack_public_path__ + "static/media/dessert.40434e81.jpg";